module.exports = __webpack_public_path__ + "static/WEDDING E&M-5-459700a5c0f50644375ce2a393fc752c.jpg";